<template>
    <div class="wrapper">
        <div class="content container">
            <header class="head">
                <router-link :to="{name: 'landing'}" class="logo">
                    <img
                        src="@/assets/imgs/landing/logo-alt.png"
                        alt=""
                        class="logo__img" />
                    <p class="logo__text">ЦИФРОВОЙ ПОМОЩНИК</p>
                </router-link>
            </header>
            <main class="main">
                <div class="information">
                    <img
                        src="@/assets/imgs/landing/info-robot.png"
                        alt=""
                        class="information__img" />
                    <div class="information-fill">
                        <p class="information__subtitle">
                            Страница генерации и предоставления кодов доступа
                            для использования сервиса
                        </p>
                        <h1 class="information__title">
                            «Цифровой помощник для выбора профессии»
                        </h1>
                        <p class="information__text information__text--2">
                            Приветствую вас! На этой странице с 14 апреля по 16
                            мая 2025 года вы можете забронировать необходимое
                            количество кодов доступа к сервису «Цифровой
                            помощник для выбора профессии» для учащихся.
                            <br /><br />
                            <span>Для этого вам необходимо:</span><br />
                            📌пройти регистрацию и достоверно заполнить все поля
                            с данными;<br />
                            📌выбрать нужное вам количество кодов в соответствии
                            с количеством учащихся, которые будут использовать
                            сервис;<br />
                            📌указать адрес действующей электронной почты, на
                            которую вы хотите получить коды;<br />
                            📌забронировать необходимое вам количество кодов
                            доступа;<br />
                            📌получить забронированные коды доступа на указанный
                            электронный адрес после завершения процесса
                            бронирования.<br />
                            <br />
                            <span>Важная информация:</span> <br />
                            📌каждый код доступа — это уникальный набор
                            символов, который можно использовать только один
                            раз, то есть только один учащийся сможет им
                            воспользоваться для использования сервиса;<br />
                            📌кодом доступа может воспользоваться учащийся,
                            рождённый ранее 2013 года (включительно, но не
                            младше);<br />
                            📌если вы бронируете несколько кодов доступа, то на
                            указанный электронный адрес вы получите то
                            количество кодов, которое указали в форме ниже;<br />
                            📌после получения кода доступа учащийся, которому вы
                            предоставите этот код, сможет зайти по ссылке -
                            <a
                                href="https://цифровойпомощник.рф"
                                target="_blank"
                                >https://цифровойпомощник.рф</a
                            >
                            - на наш сервис и воспользоваться им;<br />
                            📌с более подробной информацией об использовании
                            кода доступа вы сможете ознакомиться в инструкции,
                            которую мы вам направим после завершения процесса
                            бронирования;<br />
                            📌если ты – ученик, то проходи регистрацию по
                            основной ссылке на наш сервис;<br />
                            📌обращаем ваше внимание, что полученные коды
                            доступа будут действительны до 30 мая 2025 года.<br /><br />
                            <span>«Цифровой помощник»</span> проведёт
                            пользователя по пяти миссиям, которые подробно
                            представят и раскроют для пользователя его
                            профессиональный профиль, мотивацию, а также
                            предпринимательский потенциал. <br />
                            По итогам использования сервиса будут: <br />
                            - даны рекомендации по поступлению в образовательные
                            учреждения, а также по компетенциям, которые
                            необходимо развивать;<br />
                            - подобраны подходящие профессии и истории
                            профессионалов, которые уже трудятся по выбранной
                            ими специальности;<br />
                            - предложены работодатели для будущего
                            трудоустройства с возможностью запросить целевой
                            договор на обучение; <br />
                            - сформирован перечень профориентационных событий
                            (онлайн и оффлайн) для более полного погружения в
                            тему выбора профессии и знакомства с историями
                            профессионалов. <br />
                            Бонусом к использованию сервиса каждый пользователь
                            получит сертификат, результаты в формате pdf*, а
                            также возможность изучить бесплатный авторский курс
                            по построению карьеры. <br /><br />
                            <a href="/docs/presentation.pdf" download
                                >Пример итоговой презентации</a
                            ><br /><br />
                            <span
                                >Удачи! Если у вас остались вопросы, то можете
                                написать нам на почту:
                                <a
                                    href="malito:tsip.rf@mail.ru"
                                    target="_blank">
                                    tsip.rf@mail.ru</a
                                ></span
                            >
                        </p>
                    </div>
                </div>
                <div class="form">
                    <p class="form__title">Форма регистрации</p>
                    <p class="form__text">
                        Все поля обязательны для заполнения
                    </p>
                    <div class="list">
                        <input
                            type="text"
                            class="input"
                            placeholder="ФИО"
                            v-model="fullName" />
                        <OnClickOutside @trigger="educationVisible = false">
                            <div class="select">
                                <button
                                    class="select__button"
                                    @click="
                                        educationVisible = !educationVisible
                                    ">
                                    {{
                                        teacher_data.education ||
                                        "Тип образовательной организации"
                                    }}
                                    <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9 14.4L0 4.80005H18L9 14.4Z"
                                            fill="#AD4FEA" />
                                    </svg>
                                </button>
                                <div
                                    class="select-list"
                                    :class="{
                                        'select-list--open': educationVisible,
                                    }">
                                    <button
                                        class="select-list__button"
                                        v-for="(item, index) in educations"
                                        :key="index"
                                        @click="teacher_data.education = item">
                                        {{ item }}
                                    </button>
                                </div>
                            </div>
                        </OnClickOutside>
                        <input
                            v-model="teacher_data.educationName"
                            type="text"
                            class="input"
                            placeholder="Наименование организации" />
                        <input
                            v-model="teacher_data.jobTitle"
                            type="text"
                            class="input"
                            placeholder="Должность" />
                        <OnClickOutside @trigger="countriesVisible = false">
                            <div class="select">
                                <button
                                    class="select__button"
                                    @click="
                                        countriesVisible = !countriesVisible
                                    ">
                                    {{
                                        teacher_data.sideData.country ||
                                        "Страна"
                                    }}
                                    <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9 14.4L0 4.80005H18L9 14.4Z"
                                            fill="#AD4FEA" />
                                    </svg>
                                </button>
                                <div
                                    class="select-list"
                                    :class="{
                                        'select-list--open': countriesVisible,
                                    }">
                                    <button
                                        class="select-list__button"
                                        v-for="(item, index) in countries"
                                        :key="index"
                                        @click="
                                            teacher_data.sideData.country = item
                                        ">
                                        {{ item }}
                                    </button>
                                </div>
                            </div>
                        </OnClickOutside>
                        <OnClickOutside @trigger="regionsVisible = false">
                            <div class="select">
                                <button
                                    class="select__button"
                                    :class="{
                                        'select-list--disabled':
                                            !regions.length,
                                    }"
                                    @click="regionsVisible = !regionsVisible">
                                    {{ teacher_data.region || "Регион" }}
                                    <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9 14.4L0 4.80005H18L9 14.4Z"
                                            fill="#AD4FEA" />
                                    </svg>
                                </button>
                                <div
                                    class="select-list"
                                    :class="{
                                        'select-list--open': regionsVisible,
                                    }">
                                    <button
                                        class="select-list__button"
                                        v-for="(item, index) in regions"
                                        :key="index"
                                        @click="teacher_data.region = item">
                                        {{ item }}
                                    </button>
                                </div>
                            </div>
                        </OnClickOutside>
                        <OnClickOutside @trigger="citiesVisible = false">
                            <div class="select">
                                <button
                                    class="select__button"
                                    :class="{
                                        'select-list--disabled': !cities.length,
                                    }"
                                    @click="citiesVisible = !citiesVisible">
                                    {{
                                        teacher_data.city || "Населенный пункт"
                                    }}
                                    <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9 14.4L0 4.80005H18L9 14.4Z"
                                            fill="#AD4FEA" />
                                    </svg>
                                </button>
                                <div
                                    class="select-list"
                                    :class="{
                                        'select-list--open': citiesVisible,
                                    }">
                                    <button
                                        class="select-list__button"
                                        v-for="(item, index) in cities"
                                        :key="index"
                                        @click="teacher_data.city = item">
                                        {{ item }}
                                    </button>
                                </div>
                            </div>
                        </OnClickOutside>
                        <input
                            ref="el"
                            type="text"
                            class="input"
                            placeholder="Номер телефона" />
                        <input
                            type="email"
                            v-model.trim="teacher_data.email"
                            class="input"
                            placeholder="Электронная почта" />
                        <OnClickOutside @trigger="promocodesVisible = false">
                            <div class="select">
                                <button
                                    class="select__button"
                                    @click="
                                        promocodesVisible = !promocodesVisible
                                    ">
                                    {{
                                        count || "Необходимое количество кодов"
                                    }}
                                    <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9 14.4L0 4.80005H18L9 14.4Z"
                                            fill="#AD4FEA" />
                                    </svg>
                                </button>
                                <div
                                    class="select-list"
                                    :class="{
                                        'select-list--open': promocodesVisible,
                                    }">
                                    <button
                                        class="select-list__button"
                                        v-for="item in 30"
                                        :key="item"
                                        @click="count = item">
                                        {{ item }}
                                    </button>
                                </div>
                            </div>
                        </OnClickOutside>
                    </div>
                    <div class="code">
                        <img
                            src="@/assets/imgs/landing/code-img.png"
                            alt=""
                            class="cods__img" />
                        <div class="code-block">
                            <p class="code__number">Кол-во кодов:</p>
                            <p class="code__count">{{ count }}</p>
                        </div>
                        <div class="code-block code-block--last">
                            <p class="code__total">Всего:</p>
                            <p class="code__price">{{ totalPrice }} ₽</p>
                        </div>
                    </div>
                    <label class="check-wrapper check-wrapper--first">
                        <span class="check">
                            <input
                                type="checkbox"
                                v-model="isPolicyAccepted"
                                class="check__input" />
                            <span class="check__box"></span>
                        </span>
                        <span class="check-text">
                            Продолжая регистрацию и осуществляя пользование
                            данным онлайн-сервисом, я принимаю
                            <a
                                href="/docs/polzovatelskoe_soglashenie.pdf"
                                target="_blank"
                                >условия пользовательского соглашения,</a
                            ><a
                                href="/docs/ofer.pdf"
                                target="_blank"
                                v-if="!appConfig.appState.free">
                                договора оферты</a
                            >
                            и даю своё
                            <a
                                href="/docs/obedenunnoe_soglashenie_na_obrabotky_personalnih_dannih.pdf"
                                target="_blank"
                                class="footer__text footer__links-element"
                                >согласие на обработку персональных данных</a
                            >
                            на условиях, определённых
                            <a
                                href="/docs/politica_obrabotki_personalnih_dannih.pdf"
                                target="_blank"
                                class="footer__text footer__links-element"
                                >Политикой обработки персональных данных.</a
                            >
                        </span>
                    </label>
                    <label class="check-wrapper">
                        <span class="check">
                            <input
                                v-model="teacher_data.sideData.sendNews"
                                type="checkbox"
                                class="check__input" />
                            <span class="check__box"></span>
                        </span>
                        <span class="check-text">
                            Выражаю своё согласие на получение от АНО
                            Департамент и его партнёров информации о федеральных
                            проектах «Profstories», «Zaсобой», сервисе «Цифровой
                            помощник для выбора профессии», федеральных,
                            региональных и местных мероприятиях по
                            профориентации в форме сообщений на указанные при
                            регистрации контактные данные (адрес электронной
                            почты, телефон, мессенджеры).
                        </span>
                    </label>
                    <button
                        class="book"
                        :class="{'disabled-opacity': !isPolicyAccepted}"
                        @click="submitPayment">
                        Забронировать
                    </button>
                </div>
            </main>
            <footer class="footer">
                <div class="footer-caption">
                    <div class="footer-info">
                        <p class="footer__text">
                            АНО ДЕПАРТАМЕНТ
                            <br />
                            ИНН: 7451437188, ОГРН: 1187400001854
                        </p>
                    </div>
                    <div class="footer-info">
                        <p class="footer__text">
                            454090, Челябинская область, г.о. Челябинский, г.
                            Челябинск, пр-кт Ленина, д. 21В, офис 035<br />
                            Контактное лицо: Григорян Георгий, +7 (964)
                            792-97-22, эл. почта – tsip.rf@mail.ru
                        </p>
                    </div>
                </div>
                <p class="footer__links">
                    <a
                        href="/docs/ofer.pdf"
                        target="_blank"
                        class="footer__text footer__links-element"
                        v-if="!appConfig.appState.free"
                        >ДОГОВОР ОФЕРТА
                    </a>
                    <a
                        href="/docs/politica_obrabotki_personalnih_dannih.pdf"
                        target="_blank"
                        class="footer__text footer__links-element">
                        ПОЛИТИКА ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</a
                    >
                    <a
                        href="/docs/polzovatelskoe_soglashenie.pdf"
                        target="_blank"
                        class="footer__text footer__links-element"
                        >ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ
                    </a>
                    <a
                        href="/docs/soglashenie_na_obrabotky_personalnih_dannih.pdf"
                        target="_blank"
                        class="footer__text footer__links-element"
                        >СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ
                    </a>
                    <a
                        href="/docs/soglashenie_na_obrabotky_personalnih_dannih_nesovershennoletnih.pdf"
                        target="_blank"
                        class="footer__text footer__links-element"
                        >СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ
                        НЕСОВЕРШЕННОЛЕТНИХ
                    </a>
                </p>
            </footer>
        </div>
    </div>
</template>

<script setup>
import {appConfig} from "@/lib/appConfig";
import {OnClickOutside} from "@vueuse/components";
import {computed, ref, shallowRef, watch} from "vue";
import {useStore} from "vuex";
import {useIMask} from "vue-imask";
import locations from "@/lib/data_file.json";
import {errorHandler} from "@/lib/errorHandler";

const store = useStore();

const {el, unmasked} = useIMask({
    mask: "+{7}(000)000-00-00",
    radix: ".",
});

const educations = [
    "Общеобразовательная организация (школа)",
    "Профессиональная образовательная организация (ссуз)",
    "Образовательная организация высшего образования (вуз)",
];

const countries = computed(() => {
    return Object.keys(locations);
});

const regions = computed(() => {
    if (teacher_data.value?.sideData?.country === "Российская Федерация") {
        return Object.keys(locations[teacher_data.value?.sideData?.country]);
    }
    return [];
});
const cities = computed(() => {
    if (
        teacher_data.value?.sideData?.country === "Российская Федерация" &&
        teacher_data.value?.region
    ) {
        return locations[teacher_data.value?.sideData?.country][
            teacher_data.value?.region
        ];
    }
    return [];
});

const educationVisible = shallowRef(false);
const countriesVisible = shallowRef(false);
const regionsVisible = shallowRef(false);
const citiesVisible = shallowRef(false);
const promocodesVisible = shallowRef(false);

const isPolicyAccepted = shallowRef(false);

const count = shallowRef(0);

const totalPrice = computed(() => count.value * 499);

const teacher_data = ref({
    firstName: "",
    secondName: "",
    thirdName: "",
    region: "",
    city: "",
    education: "", // школа, вуз
    educationName: "", //название учреждения
    jobTitle: "", // класс, курс
    email: "",
    phone: "",
    sideData: {
        country: "",
        sendNews: false,
    },
});

const fullName = shallowRef("");

function submitPayment() {
    if (!isPolicyAccepted.value) {
        return;
    }

    if (
        !teacher_data.value.firstName?.trim() ||
        !teacher_data.value.secondName?.trim() ||
        !teacher_data.value.thirdName?.trim()
    ) {
        return errorHandler({name: "InvalidField", field: "name"});
    }

    if (!teacher_data.value.education?.trim()) {
        return errorHandler({name: "InvalidField", field: "education"});
    }

    if (!teacher_data.value.educationName?.trim()) {
        return errorHandler({name: "InvalidField", field: "educationName"});
    }

    if (!teacher_data.value.sideData.country) {
        return errorHandler({name: "InvalidField", field: "country"});
    }

    if (!teacher_data.value.region) {
        return errorHandler({name: "InvalidField", field: "region"});
    }

    if (!teacher_data.value.city) {
        return errorHandler({name: "InvalidField", field: "city"});
    }

    if (
        !teacher_data.value.phone?.trim() ||
        teacher_data.value.phone.length !== 11
    ) {
        return errorHandler({name: "InvalidField", field: "phone"});
    }

    if (
        !teacher_data.value.email ||
        !/^[\w-\\.]+@[\w-]+\.[a-z]{2,4}$/i.test(teacher_data.value.email)
    ) {
        return errorHandler({name: "InvalidField", field: "email"});
    }

    if (!count.value) {
        return errorHandler({name: "InvalidField", field: "promocodesCount"});
    }

    const data = {
        email: teacher_data.value.email,
        count: count.value,
        teacher_data: JSON.stringify(teacher_data.value),
    };

    store.dispatch("submitPromocodePayment", data);
}

watch(fullName, (value) => {
    const nameSplit = value?.split(" ");
    const [secondName, firstName, thirdName] = nameSplit;
    teacher_data.value.firstName = firstName;
    teacher_data.value.secondName = secondName;
    teacher_data.value.thirdName = thirdName;

    if (nameSplit.length > 3) {
        nameSplit.length = 3;
        fullName.value = nameSplit.join(" ");
    }
});

watch(
    () => teacher_data.value.sideData.country,
    (val) => {
        if (val === "Российская Федерация") {
            teacher_data.value.region = "";
            teacher_data.value.city = "";
        } else {
            teacher_data.value.region = "Другой";
            teacher_data.value.city = "Москва";
        }
    }
);

watch(unmasked, (val) => {
    teacher_data.value.phone = val;
});
</script>

<style scoped>
.wrapper {
    background: #020410;
    width: 100%;
}

.container {
    max-width: 1632px;
    padding: 24px 16px;
}

.head {
    max-width: 100%;
    width: 100%;
}

.logo {
    display: flex;
    align-items: center;
    gap: 16px;
}

.logo__text {
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    background: linear-gradient(151deg, #e5bdff 0%, #b5bcff 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.main {
    margin-top: 86px;
}

.information {
    background: linear-gradient(151deg, #ad4fea 0%, #4a58dd 100%);
    width: 100%;
    border-radius: 40px;
    padding-right: 56px;
    padding-bottom: 41px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.information__img {
    position: relative;
    top: -74px;
    width: 386px;
}

.information-fill {
    margin-top: 66px;
    max-width: 1125px;
}

.information__subtitle {
    font-size: 27px;
    color: #fff;
}

.information__title {
    margin-top: 16px;
    font-weight: 700;
    font-size: 48px;
}

.information__text {
    margin-top: 24px;
    font-weight: 400;
    font-size: 24px;
    color: #fff;
    line-height: 140%;
}

.information__text span {
    font-weight: 700;
}

.information__text a {
    font-weight: 700;
    color: #fff;
}

.form {
    margin-top: 24px;
    background: #313131;
    padding: 45px;
    border-radius: 45px 56px 33px 45px;
}

.form__title {
    font-weight: 700;
    font-size: 48px;
    color: #fff;
}

.form__text {
    margin-top: 8px;
    font-weight: 400;
    font-size: 24px;
    color: rgba(255, 255, 255, 0.5);
}

.list {
    margin-top: 32px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 24px;
    column-gap: 76px;
}

.input {
    min-height: 72px;
    border: 1px solid #ad4fea;
    border-radius: 8px;
    padding: 20px 24px;
    font-size: 24px;
    line-height: 120%;
    color: #020410;
    background: #fff;
}

.input::placeholder {
    color: #aeafb1;
}

.select {
    position: relative;
}

.select__button {
    background: #fff;
    min-height: 72px;
    border: 1px solid #ad4fea;
    border-radius: 8px;
    color: #aeafb1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-size: 24px;
    line-height: 120%;
    padding: 20px 24px;
}

.select-list {
    position: absolute;
    scrollbar-width: thin;
    border: 1px solid #ad4fea;
    border-radius: 8px;
    color: #aeafb1;
    flex-direction: column;
    max-width: 100%;
    width: 100%;
    z-index: 3;
    opacity: 0;
    transition: all 0.5s ease-in-out;
    background: unset;
    padding-bottom: 0;
    max-height: 20rem;
    overflow: auto;
    pointer-events: none;
    display: flex;
    width: 100%;
    background: #fff;
}

.select-list__button {
    width: 100%;
    transition: all 0.5s ease-in-out;
    color: #aeafb1;
    border-bottom: 1px solid #ad4fea;
    font-size: 24px;
    line-height: 120%;
    padding: 20px 24px;
    cursor: pointer;
}

.select-list__button:last-child {
    border-bottom: none;
}

.select-list--open {
    opacity: 1;
    pointer-events: all;
}

.select-list--disabled {
    opacity: 0.6;
    pointer-events: none;
}

.code {
    margin-top: 32px;
    display: flex;
    align-items: center;
    gap: 30px;
}

.code-block {
    display: flex;
    align-items: center;
    gap: 36px;
}

.code-block--last {
    margin-left: auto;
}

.code__number {
    font-weight: 400;
    font-size: 40px;
    letter-spacing: -0.01em;
    color: #fff;
}

.code__count {
    font-weight: 700;
    font-size: 36px;
    letter-spacing: -0.01em;
    background: linear-gradient(151deg, #be5aff 15.1%, #949eff 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.code__total {
    font-weight: 400;
    font-size: 40px;
    letter-spacing: -0.01em;
    color: #fff;
}

.code__price {
    font-weight: 700;
    font-size: 48px;
    letter-spacing: 0em;
    background: linear-gradient(151deg, #be5aff 15.1%, #949eff 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.check-wrapper {
    margin-top: 16px;
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    max-width: 100%;
    width: 100%;
    cursor: pointer;
}

.check-wrapper--first {
    margin-top: 40px;
}

.check-text {
    font-size: 24px;
    line-height: 133%;
    color: #fff;
    font-size: 1.5rem;
    font-family: "Roboto", sans-serif;
}

.check-text a {
    text-decoration-skip-ink: none;
    color: #4a58dd;
    display: inline;
}

.check-wrapper--first {
    margin-top: 40px;
}

.check {
    display: flex;
    flex-shrink: 0;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
}

.check:hover {
    opacity: 0.8;
}

.check__input {
    position: absolute;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 0;
    height: 0;
}

.check__box {
    width: 100%;
    height: 100%;
    background: center / cover no-repeat url("@/assets/imgs/check__box-new.svg");
}

.check__input:checked ~ .check__box {
    background: center / cover no-repeat
        url("@/assets/imgs/check__box-new-on.svg");
}

.book {
    margin-top: 40px;
    border-radius: 16px;
    padding: 24px;
    min-height: 80px;
    background: linear-gradient(151deg, #ad4fea 0%, #4a58dd 100%);
    width: 100%;
    font-weight: 700;
    font-size: 32px;
    text-align: center;
    color: #fff;
}

@media (max-width: 850px) {
    .main {
        margin-top: 60px;
    }

    .information {
        border-radius: 20px;
        padding: 20px;
        flex-direction: column;
        gap: 12px;
    }

    .information__img {
        position: relative;
        top: unset;
        width: 300px;
        margin: 0 auto;
    }

    .information-fill {
        margin-top: 0px;
    }

    .information__subtitle {
        font-size: 23px;
    }

    .information__title {
        margin-top: 16px;
        font-weight: 700;
        font-size: 32px;
    }

    .information__text {
        margin-top: 16px;
        font-size: 16px;
    }

    .form {
        margin-top: 24px;
        border-radius: 20px;
        padding: 20px;
    }

    .form__title {
        font-size: 32px;
    }

    .form__text {
        font-size: 16px;
    }

    .list {
        margin-top: 24px;
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 20px;
    }

    .input {
        min-height: unset;
        border-radius: 8px;
        padding: 12px 16px;
        font-size: 16px;
    }

    .input::placeholder {
        color: #aeafb1;
    }

    .select {
        position: relative;
    }

    .select__button {
        min-height: unset;
        border-radius: 8px;
        padding: 12px 16px;
        font-size: 16px;
    }

    .select__button svg {
        width: 14px;
    }

    .select-list {
        border-radius: 8px;
    }

    .select-list__button {
        padding: 12px 16px;
        font-size: 16px;
    }

    .code {
        margin-top: 20px;
        align-items: center;
        flex-wrap: wrap;
    }

    .code-block {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .code-block--last {
        margin-left: 0;
    }

    .code__number {
        font-size: 24px;
    }

    .code__count {
        font-size: 24px;
    }

    .code__total {
        font-size: 24px;
    }

    .code__price {
        font-size: 24px;
    }

    .check-wrapper {
        margin-top: 16px;
    }

    .check-text {
        font-size: 16px;
    }

    .check {
        width: 20px;
        height: 20px;
    }

    .check:hover {
        opacity: 0.8;
    }

    .book {
        margin-top: 24px;
        padding: 16px;
        min-height: unset;
        width: 100%;
        font-size: 20px;
    }
}

.footer {
    color: rgba(255, 255, 255, 0.5);
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.3;
    margin-top: 4.5rem;
    margin-bottom: 7.5rem;
}

.footer-caption {
    display: flex;
    gap: 1.25rem;
    justify-content: space-between;
}

.footer-info {
    max-width: 100%;
    width: 100%;
}

.footer__links {
    margin-top: 1rem;
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0.3rem;
    max-width: 100%;
    width: 100%;
}

.footer__links-element {
    text-decoration: underline;
}

.footer__text {
    line-height: 1.3;
}

.footer-companies {
    margin-top: 2.313rem;
    padding-top: 2.313rem;
    border-top: 1px solid rgba(255, 255, 255, 0.5);
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.25rem;
    justify-content: space-between;
}

.profstor {
    width: 6.66444rem;
}

.za {
    width: 15.3125rem;
}

.min {
    width: 16.6875rem;
}

.work {
    width: 12rem;
}

@media (max-width: 850px) {
    .footer {
        font-size: 0.625rem;
        margin-top: 2.5rem;
        margin-bottom: 2.31rem;
    }

    .footer-caption {
        max-width: 100%;
        gap: 1.06rem;
        flex-direction: column;
        align-items: flex-start;
    }

    .footer-info {
        order: 2;
    }

    .footer__text {
        line-height: 1.3;
    }

    .footer-companies {
        margin-top: 2.75rem;
        padding-top: 0.75rem;
        border-top: 1px solid rgba(255, 255, 255, 0.5);
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 0.63rem;
    }

    .footer__links {
        margin-top: 1.5rem;
    }

    .profstor {
        order: 3;
        width: 4.92988rem;
    }

    .za {
        order: 1;
        width: 8.5625rem;
    }

    .min {
        width: 8.1875rem;
        height: 2.0625rem;
        order: 2;
    }

    .work {
        width: 6.6875rem;
        height: 2.5625rem;
        order: 4;
        margin-right: 1rem;
    }
}
</style>
